export enum CustomEventType {
    AuthModal = 'open-auth-modal',
    CartLimit = 'cart-limit',
    ShowPageLoading = 'show-page-loading',
    HidePageLoading = 'hide-page-loading',
    TooManyRequests = 'too-many-requests',
    PaymentUnavailable = 'payment-unavailable',
}
